<nav aria-label="breadcrumb" class="breadcrumbs">
  <ol class="breadcrumb-list">
    <li *ngFor="let crumb of breadcrumbs; let last = last" class="breadcrumb-item">
      <ng-container *ngIf="!last; else lastBreadcrumb">
        <a [routerLink]="crumb.url" class="breadcrumb-link">{{ crumb.label }}</a>
        <span class="separator"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
<path d="M13.7688 6.54554C13.9156 6.40491 14 6.20804 14 6.00179C14 5.79554 13.9156 5.60179 13.7688 5.45804L8.26875 0.208037C7.96875 -0.0794632 7.49375 -0.0669631 7.20937 0.233037C6.925 0.533037 6.93437 1.00804 7.23438 1.29241L11.3781 5.25179H0.75C0.334375 5.25179 0 5.58616 0 6.00179C0 6.41741 0.334375 6.75179 0.75 6.75179H11.3781L7.23125 10.708C6.93125 10.9955 6.92188 11.4674 7.20625 11.7674C7.49063 12.0674 7.96562 12.0768 8.26562 11.7924L13.7656 6.54241L13.7688 6.54554Z" fill="#5C6278"/>
</svg></span>
      </ng-container>

      <ng-template #lastBreadcrumb>
        <span class="breadcrumb-active">{{ crumb.label }}</span>
      </ng-template>
    </li>
  </ol>
</nav>